$(() => {
  // CODE IN HERE
  loadCustomFeatures();

  /* CURRENT VWO TESTS */
  // try { cartPageHideFoilCharge() } catch (e) { console.warn(e) }
  // $(window).on('infinityOptionsLoaded', () => sortColorsByPopularity());

  /* EXAMPLE OF TYPICAL INIT FN
    try { initSomeFeature() } catch(e) { console.warn(e) }
  */
});

const initFunctionsByKeyword = {
  'embosser': initEmbosserFeatures,
  'our-wedding-planner': initOurWeddingPlannerFeatures
}

function loadCustomFeatures() {
  try {
    const productMetafields = JSON.parse($("#metafields").html());
    const initFunction = initFunctionsByKeyword[productMetafields.keyword];
    if (initFunction)
      initFunction();
    else
      console.warn('No initialization function found for keyword:', productMetafields.keyword);
  }
  catch (e) {
    console.error('Error parsing metafields or initializing features:', e);
  }
}

function initEmbosserFeatures() {
 $(document).on('click', '.product__details .spb-productoptionswatch', function() {
      showEmbosserDesignPreview($(this));
  });
}

function showEmbosserDesignPreview($clickedElement) {
    console.log('showing preview...');
    
    selectLastGalleryImage();
    updateDesignPreview($clickedElement);
}

function selectLastGalleryImage() {
    // Get Flickity instance
    const flkty = Flickity.data('.product_gallery');
    if (flkty) {
        // Disable accessibility temporarily to prevent jumping
        const wasAccessible = flkty.options.accessibility;
        flkty.options.accessibility = false;
        
        // Select last cell
        const lastIndex = flkty.cells.length - 1;
        flkty.select(lastIndex, false, true);  // immediate select without animation
        
        // Restore accessibility
        flkty.options.accessibility = wasAccessible;
    } else {
        // Fallback for when Flickity isn't initialized
        const $lastGalleryCell = $('.flickity-slider .gallery-cell').last();
        $lastGalleryCell.click();
    }
}

function updateDesignPreview($clickedElement) {
    const styleValue = getStyleValue($clickedElement);
    if (!styleValue) return;

    const imageUrl = extractImageUrl(styleValue);
    if (!imageUrl) return;

    updateImageAttributes(imageUrl);
}

function getStyleValue($clickedElement) {
    const styleValue = $clickedElement.attr("style");
    if (!styleValue) {
        console.error('No style attribute found on element:', $clickedElement);
        return null;
    }
    console.log('Style value:', styleValue);
    return styleValue;
}

function extractImageUrl(styleValue) {
    try {
        const urlMatch = styleValue.match(/background-image:\s*url\(['"]?(.*?)['"]?\)/i);
        
        if (!urlMatch || !urlMatch[1]) {
            console.error('No valid URL found in style:', styleValue);
            return null;
        }

        const url = urlMatch[1];
        console.log('Extracted URL:', url);
        return url;
    } catch (error) {
        console.error('Error extracting URL from style:', styleValue);
        console.error('Error details:', error);
        return null;
    }
}

function updateImageAttributes(url) {
    $('[alt="design-preview"]')
        .attr({
            'src': url,
            'data-src': url,
            'srcset': ''
        })
        .removeAttr('data-srcset');
}

function initOurWeddingPlannerFeatures() {
  /* try catch to wrap each custom js fn so it doesn't block */
  try { tryInfiniteOptionsLoaded() } catch (e) { console.warn(e) }
  $(window).on('infinityOptionsLoaded', () => initColorPreview()); 
}

function cartPageHideFoilCharge() {
  console.log('cartPageFoilCharge');
  try {
    if (location.pathname != '/cart') return;
    var $foilCharges = $('h3 a:contains("Foil Charge")');
    for (var i = 0; i < $foilCharges.length; i++) {
      var $foilCharge = $($foilCharges[i]);
      var $foilChargeParent = $foilCharge.closest('.cart__item');
      var $parentItem = $foilChargeParent.prev();
      console.log('❗❗found?', $foilCharge.length, $foilChargeParent.length, $parentItem.length);
      if ($parentItem.length && $parentItem.find('.cart__product-option-name:contains("Foil Color:")').length) {
        // this foil charge has a parent
        var foilChargeAmount = +$foilChargeParent.find('span.money:first').text().replace('$', '');
        console.log('foil amount', foilChargeAmount);
        // add it to parent item
        var $parentItemMoneys = $parentItem.find('span.money');
        for (var j = 0; j < $parentItemMoneys.length; j++) {
          var $parentItemMoney = $($parentItemMoneys[j]);
          var parentItemAmount = +$parentItemMoney.text().replace('$', '');
          $parentItemMoney.text(`$${(parentItemAmount + foilChargeAmount).toFixed(2)}`);
        }
        $parentItem.animate({ opacity: 1 }, 500);
      } else {
        // this foil charge's parent is gone
        $foilChargeParent.animate({ opacity: 1 }, 500);
        $parentItem.animate({ opacity: 1 }, 500);
      }
    }
    if ($foilCharges.length == 0) {
      $('.cart__item').animate({ opacity: 1 }, 500);
    }
  } catch (e) {
    console.warn(e);
    $('.cart__item').css({ opacity: 1 });
  }
}

function tryInfiniteOptionsLoaded() {
  if (!location.pathname.includes('/products/')) return;
  var intervalId = null;
  var start = new Date();
  intervalId = setInterval(function() {
    // elements to test for
    var $colors = $('#infiniteoptions-container');
    var $radios = $(`form input[type="radio"][name="properties[Color]"]`);
    var $fontRadios = $(`form input[type="radio"][name="properties[Font Color]"]`);
    var $foilRadios = $(`form input[type="radio"][name="properties[Foil Color]"],form input[type="radio"][name-disabled="properties[Foil Color]"]`);
    var $letteringRadios = $(`form input[type="radio"][name="properties[Lettering]"]`);
    console.log('infinite options test', $colors.length, $radios.length, $fontRadios.length, $foilRadios.length);
    if ($colors.length && $radios.length && ($fontRadios.length + $foilRadios.length + $letteringRadios)) {
      clearInterval(intervalId);
      // TRIGGER
      $(window).trigger('infinityOptionsLoaded');
      $('form.shopify-product-form').addClass('infinityOptionsLoaded');
    } else {
      // a time limit for trying
      if (new Date().getTime() - start.getTime() > 12000) {
        clearInterval(intervalId);
      }
    }
  }, 250); // try every 250ms
}

function preloadPreviewAssets($coverRadios, $fontRadios, $foilRadios, $letteringRadios) {
  // assets were slow to load using the src overwrite method. Preload all the assets in memory here
  var assetUrls = [];
  for (var i = 0; i < $coverRadios.length; i++) {
    var value = $($coverRadios.get(i)).attr('value');
    assetUrls.push(`https://cdn.shopify.com/s/files/1/0485/5454/1218/files/preview-wp-${value.toLowerCase().split(' ').join('-')}.png`);
  }
  // for (var i = 0; i < $fontRadios.length; i++) {
  //   var value = $($fontRadios.get(i)).attr('value');
  //   assetUrls.push(`https://cdn.shopify.com/s/files/1/0485/5454/1218/files/preview-our-wedding-${value.toLowerCase().split(' ').join('-')}.png`);
  // }
  // for (var i = 0; i < $foilRadios.length; i++) {
  //   var value = $($foilRadios.get(i)).attr('value');
  //   assetUrls.push(`https://cdn.shopify.com/s/files/1/0485/5454/1218/files/preview-our-wedding-${value.toLowerCase().split(' ').join('-')}.png`);
  // }
  for (var i = 0; i < $letteringRadios.length; i++) {
    var value = $($letteringRadios.get(i)).attr('value');
    assetUrls.push(`https://cdn.shopify.com/s/files/1/0485/5454/1218/files/preview-our-wedding-${value.toLowerCase().split(' ').join('-')}.png`);
  }
  assetUrls.forEach(url => {
    var img = new Image();
    img.src = url;
  });
}

function initColorPreview() {
  console.log('initColorPreview');
  // test product page
  var supportedProductPages = ['our-wedding-planner', 'our-wedding-planner-d'];
  if (!location.pathname.includes('/products/') || !supportedProductPages.includes(location.pathname.split('/products/')[1])) return;
  
  var $form = $('form.shopify-product-form');
  var $infiniteColors = $('#infiniteoptions-container');
  var $radios = $form.find(`input[type="radio"][name="properties[Color]"]`);
  var $fontRadios = $form.find(`input[type="radio"][name="properties[Font Color]"]`);
  var $foilRadios = $form.find(`input[type="radio"][name="properties[Foil Color]"],input[type="radio"][name-disabled="properties[Foil Color]"]`);
  var $letteringRadios = $form.find(`input[type="radio"][name="properties[Lettering]"]`);

  preloadPreviewAssets($radios, $fontRadios, $foilRadios, $letteringRadios);

  var $css = $(`
    <style id="colorPreviewStyle">
      #colorPreview {
        width: 100%;
        max-width: 300px;
        position: relative;
      }
      .colorPreview-cover, .colorPreview-text {
        position: absolute; left: 0; top: 0;
        width: 100%;
      }
      .colorPreview-inset {
        position: absolute; left: 0; top: 0;
        width: 100%;
        height: 100px;
        font-size: 0;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.15) inset;
      }
      .colorPreview-bg {
        width: 100%;
      }
      .colorPreview-previewLabel, .colorPreview-label {
        position: absolute;
        right: 5%;
        top: 0;
        color: white;
        font-weight: 500;
        font-style: italic;
        font-size: 1.1em;
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.9);
      }
     .colorPreview-label {
        position: absolute;
        left: 5%; right: auto; top: auto;
        bottom: .75em;
      }
    </style>
  `);
  var $preview = $(`
    <div id="colorPreview">
        <img class="colorPreview-bg" src="https://cdn.shopify.com/s/files/1/0485/5454/1218/files/grassy-field-bg.jpg?" onerror="removeColorPreview(this.src)" />
        <img class="colorPreview-cover" src="https://cdn.shopify.com/s/files/1/0485/5454/1218/files/preview-wp-swiss-coffee.png?" onerror="removeColorPreview(this.src)" />
        <img class="colorPreview-text" src="https://cdn.shopify.com/s/files/1/0485/5454/1218/files/preview-our-wedding-gold.png?" onerror="removeColorPreview(this.src)" />
        <div class="colorPreview-inset"></div>
        <span class="colorPreview-previewLabel">your preview</span>
        <span class="colorPreview-label">your options</span>
      </div>
    </div>
  `);
  // events
  $radios.on('update change', function(el) {
    reflectColorPreview();
  });
  $fontRadios.on('change', function(el) {
    reflectColorPreview();
  });
  $foilRadios.on('change', function(el) {
    reflectColorPreview();
  });
  $letteringRadios.on('change', function(el) {
    reflectColorPreview();
  });
  // the "Add Foil? Yes Please" checkbox should also trigger
  $('input.spb-productoptiontextcolor.spb-productoptionbackground[type=checkbox]').on('change', function(el) {
    // this one has a bit of a delay
    setTimeout(() => {
      reflectColorPreview();
    }, 250)
  });
  $form.prepend($css);
  $form.prepend($preview);
  $form.addClass('initColorPreview');
  // set the initial state of preview
  reflectColorPreview();
}

function reflectColorPreview() {
  var coverColor = $(`form input[type="radio"][name="properties[Color]"]:checked`).val() || ''; 
  var fontColor = $(`form input[type="radio"][name="properties[Font Color]"]:checked`).val() || $(`form input[type="radio"][name="properties[Foil Color]"]:checked`).val() || '';
  if (!fontColor) {
    fontColor = $(`form input[type="radio"][name="properties[Lettering]"]:checked`).val();
  }
  $('img.colorPreview-cover').attr('src', `https://cdn.shopify.com/s/files/1/0485/5454/1218/files/preview-wp-${coverColor.toLowerCase().split(' ').join('-')}.png`);
  $('img.colorPreview-text').attr('src', `https://cdn.shopify.com/s/files/1/0485/5454/1218/files/preview-our-wedding-${fontColor.toLowerCase().split(' ').join('-')}.png`);
  $('.colorPreview-label').text(`${fontColor} + ${coverColor}`);
}

function removeColorPreview(src) {
  console.warn('could not find img src, hiding preview', src);
  // called if any required resources are missing (404)
  $('#colorPreview').remove();
}

function sortColorsByPopularity() {
  // test product page
  var supportedProductPages = ['our-wedding-planner', 'our-wedding-planner-d'];
  if (!location.pathname.includes('/products/') || !supportedProductPages.includes(location.pathname.split('/products/')[1])) return;
  
  if ($('form.shopify-product-form').hasClass('colorsSorted')) return;
  console.log('sortColorsByPopularity()');
  // from AT orders investigation 11/1/2024
  var sortOrder = [
    'Textured Sage', 'Dusty Blue', 'Swiss Coffee',
    'Clary Sage', 'Emerald', 'Dark Seafoam',
    'Dusty Pink', 'Pewter Cast', 'White',
    'Pale Amethyst', 'Black', 'Oxford Blue',
    'Beige', 'Blush Pink', 'Lavender',
    'Rust', 'Smokey Grape', 'Classic Gray',
    'Rose', 'Marigold'
  ];
  var detachedByValue = {};
  // detect before detach, in case there's a selection problem
  var ok = true;
  sortOrder.forEach(name => {
    var $wrapper = $(`form input[name="properties[Color]"][value="${name}"]`).closest('label'); // should be a <label class="spb-productoptiontextcolor">
    detachedByValue[name] = $wrapper;
    if (detachedByValue[name].length != 1) ok = false;
  });
  if (!ok) return console.warn('sortColorsByPopularity could not match up cover options');

  var $container = $('div.cover-color-swatch-container > span');
  if ($container.length != 1) return console.warn(`sortColorsbyPopularity could not find container of sortables`);
  
  // now detach, won't reach here if a selection was not found
  for (var name in detachedByValue) {
    detachedByValue[name] = detachedByValue[name].detach();
  }
  // now reattach in sequence
  sortOrder.forEach(name => {
    $container.append(detachedByValue[name]);
  });

  // finally, select the default
  setTimeout(function() {
    $(`form input[name="properties[Color]"][value="${sortOrder[0]}"]`).click();
    $('input.spb-productoptiontextcolor.spb-productoptionbackground[type=checkbox]').click();
  }, 150);

  $('form.shopify-product-form').addClass('colorsSorted');
}